import { DEFAULT_REVIEW_FEATURE_CONFIG, REVIEW_FEATURES } from '../../common/review-mode-side-panel';
export const DEFAULT_REVIEW_MODE_FEATURE_CONFIG_ULABEL_LITE = {
  ...DEFAULT_REVIEW_FEATURE_CONFIG,
  [REVIEW_FEATURES.ACCEPT_REJECT_TASK]: false,
  // for task level accept reject
  [REVIEW_FEATURES.ACCEPT_REJECT_LABEL]: true,
  // for label level accept reject
  [REVIEW_FEATURES.ENABLE_COMMENTS_FEEDBACK]: false,
  // to capture comments
  [REVIEW_FEATURES.ENABLE_MISSING_LABELS_FEEDBACK]: false,
  // to report missing labels
  [REVIEW_FEATURES.CAN_EDIT]: true,
  // to edit the labels
  [REVIEW_FEATURES.ENABLE_CONTINUOUS_PLAYBACK]: false,
  // to enable continuous playback for entity tagging
  [REVIEW_FEATURES.ENABLE_BATCH_MODE]: false // to enable batch mode in entity tagging
};
export const REVIEW_MODE_VERSION_ULABEL_LITE = 2;